
import { createClient } from '@supabase/supabase-js';

/**
 * Prioriza variáveis de ambiente do Vite/Vercel.
 * Se não encontradas, usa os fallbacks configurados inicialmente.
 */
const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || 'https://uvfkbraetjtxxzhebvli.supabase.co';
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV2ZmticmFldGp0eHh6aGVidmxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwMzM1MjUsImV4cCI6MjA4NjYwOTUyNX0.KjMk2-ABPEMB_zz9hzfSdIbKA1eqya5g0Q1gWpDY3kw';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase URL e Anon Key são obrigatórios.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
